import { Module } from 'vuex'

import { RootState } from '../state'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { PaymentMethodState } from './state'

const namespaced = true

const state: PaymentMethodState = {
  allPaymentMethods: {
    elements: []
  },
  allowedPaymentMethods: {
    elements: []
  }
}

const module: Module<PaymentMethodState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}

export default module
